import { render, staticRenderFns } from "./TutorialVideoDialog.vue?vue&type=template&id=2c412476"
import script from "./TutorialVideoDialog.vue?vue&type=script&lang=js"
export * from "./TutorialVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports